import { Icon } from "equator-design-system";

type SuggestedPromptCardProps = {
  title: string;
  description: string;
  /** Equator design-system icon id served by the prompt template API. */
  icon: string;
  onSelect: () => void;
  disabled?: boolean;
};

const SuggestedPromptCard = ({
  title,
  description,
  icon,
  onSelect,
  disabled
}: SuggestedPromptCardProps) => (
  <button
    type="button"
    onClick={onSelect}
    disabled={disabled}
    className="flex h-full w-full flex-col gap-3 rounded-xl border border-gainsboro bg-white p-[18px] text-left transition-colors hover:border-teal-300 hover:bg-teal-50 disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:border-gainsboro disabled:hover:bg-white"
    data-testid={`agentic-ai-suggested-prompt-${title.toLowerCase().replace(/\s/g, "-")}`}
  >
    <span aria-hidden className="block size-6">
      <Icon
        name={icon}
        loadableStatus={false}
        width={24}
        height={24}
        className="text-dim-gray"
      />
    </span>
    <span className="text-base font-semibold text-txtHeading">{title}</span>
    <span className="text-xs leading-relaxed text-txtBody">{description}</span>
  </button>
);

export default SuggestedPromptCard;
